import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import * as artifactActions from '~/artifact/actions';
type ArtifactViewMainContentFixInfoFixDetailsHeaderProps = {
  actions: object;
  text: string;
  section: string;
  activeSection: string;
};
class ArtifactViewMainContentFixInfoFixDetailsHeader extends React.Component<
  ArtifactViewMainContentFixInfoFixDetailsHeaderProps,
  {}
> {
  updateFixSection = () => {
    this.props.actions.updateFixSection(this.props.section);
  };
  render() {
    let text = this.props.text,
      section = this.props.section,
      activeSection = this.props.activeSection,
      isActive = section === activeSection,
      containerClasses,
      textClasses;
    containerClasses = classNames({
      grid: true,
      'bo-b--5': true,
      'pb--': true,
      'cursor--pointer': true,
      'border-color--transparent': !isActive,
      'border-color--primary': isActive,
      'flex flex--justify-content--center': true,
    });
    textClasses = classNames({
      'font--h6': true,
      'text--bold': isActive,
    });
    return (
      <div className={containerClasses} onClick={this.updateFixSection}>
        <span className={textClasses}>{text}</span>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    routing: state.routing,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewMainContentFixInfoFixDetailsHeader);
